export const RESET_STATE = 'ORGANIZATION/CREATE/RESET_STATE'
export const SUBMIT_USER_PASSWORD = 'ORGANIZATION/CREATE/SUBMIT_USER_PASSWORD'
export const SET_USER_INFORMATIONS = 'ORGANIZATION/CREATE/SET_USER_INFORMATIONS'
export const SET_ONBOARDING_TEMPLATES =
  'ORGANIZATION/CREATE/SET_ONBOARDING_TEMPLATES'
export const CHECK_DOMAIN = 'ORGANIZATION/CREATE/CHECK_DOMAIN'
export const CHANGE_STEP = 'ORGANIZATION/CREATE/CHANGE_STEP'
export const SET_APP_PATH = 'ORGANIZATION/CREATE/SET_APP_PATH'
export const JOIN = 'ORGANIZATION/CREATE/JOIN'
export const SET_ORGANIZATION_DETAILS =
  'ORGANIZATION/CREATE/SET_ORGANIZATION_DETAILS'
export const SET_CREATE_ORG_ERROR = 'ORGANIZATION/CREATE/SET_CREATE_ORG_ERROR'
export const USER_PICKS_EMAIL_SIGNUP =
  'ORGANIZATION/CREATE/USER_PICKS_EMAIL_SIGNUP'
export const SET_EMAIL_VERIFICATION_CODE =
  'ORGANIZATION/CREATE/SET_EMAIL_VERIFICATION_CODE'
export const SKIP_EXISTING_ORG_SUGGESTIONS =
  'ORGANIZATION/CREATE/SKIP_EXISTING_ORG_SUGGESTIONS'
export const CHECK_EMAIL_HANDLER = 'ORGANIZATION/CREATE/CHECK_EMAIL_HANDLER'
export const CANCEL_SIGNUP_REMINDER = 'CANCEL_SIGNUP_REMINDER'
